import Vue from "vue";
import Router from "vue-router";
import Transform from "./views/Transform";
import EditImg from "./views/EditImg";
import Compress from "./views/Compress";

Vue.use(Router)

const router = new Router({
    base: process.env.BASE_URL,
    mode: "history",
    routes: [
        //默认在线转换
        {
            path: "/",
            name: "index",
            component: EditImg,
            meta: {
                title: "图片编辑"
            }
        },
        {
            path: "/edit",
            name: "editImg",
            component: EditImg,
            meta: {
                title: "图片编辑"
            }
        },
        {
            path: "/transform",
            name: "transform",
            component: Transform,
            meta: {
                title: "格式转换"
            }
        },
        {
            path: "/compress",
            name: "compress",
            component: Compress,
            meta: {
                title: "图片压缩"
            }
        },
    ]
})
export default router
